import { useDispatch, useSelector } from "react-redux";
import { updateConfig } from "../../../../../store/slices/Orders/orderSlice";

const useService = () => {
  const dispatch = useDispatch();
  const { orderStatus } = useSelector((state) => state.addOrder);

  const handleCloseModal = () => {
    dispatch(
      updateConfig((state) => {
        state.showAddOrderModal = false;
        state.isOldCertificate = false;
      })
    );
  };

  return {
    orderStatus,
    handleCloseModal,
  };
};

export default useService;
